import React from 'react'

export const DefaultRenderer = ({value, color, text} = {}) => (
  <span style={{color}} title={text}>{value}</span>
)
